import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh from './locales/zh.json';
import en from './locales/en.json';

const savedLang = typeof window !== 'undefined'
  ? localStorage.getItem('uo_lang') || 'zh'
  : 'zh';

i18n.use(initReactI18next).init({
  resources: {
    zh: { translation: zh },
    'zh-TW': { translation: zh },
    en: { translation: en },
  },
  lng: savedLang,
  fallbackLng: 'zh',
  interpolation: { escapeValue: false },
});

export default i18n;

export function switchLanguage(lang: 'zh' | 'en') {
  i18n.changeLanguage(lang);
  localStorage.setItem('uo_lang', lang);
}
